import script from "./CardMitiRegistro.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMitiRegistro.vue?vue&type=script&setup=true&lang=js"

import "./CardMitiRegistro.vue?vue&type=style&index=0&id=cd45dc70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd45dc70"]])

export default __exports__